import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../utils/Network'
import { getUsersFilterSelectStyles, makeDarkSelectStyles } from './selectStyles';

export default function SelectMonth({ callback, value, width ,name, usersFilter, placeholder, border }) {

    const customStyles = usersFilter
        ? getUsersFilterSelectStyles({ width: width || '100px', border: 1 })
        : makeDarkSelectStyles({ width: width || '100px', border });


    const months = new Array(11);
    months[0] = "Jan";
    months[1] = "Feb";
    months[2] = "Mar";
    months[3] = "Apr";
    months[4] = "May";
    months[5] = "Jun";
    months[6] = "Jul";
    months[7] = "Aug";
    months[8] = "Sep";
    months[9] = "Oct";
    months[10] = "Nov";
    months[11] = "Dec";
    
    var options = []
    Array.from(months, (e, i) => {
        var option = null;
        option = {
            label: months[i],
            value: i+1
        }
        options.push(option)
    })

    const handleSelect = (e) => {
        value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "Month"}
                    value={options && options.filter(obj => obj.value == value)}
                    menuPortalTarget={usersFilter ? document.body : undefined}
                    menuPosition={usersFilter ? 'fixed' : undefined}
                />
            </div>

        </>
    )
}
